import { CatalogAppSettings } from '@/common/services/swagger/index.defs';
import { IComponentOptions } from '../runtime/IComponentOptions';
import { IOptions } from '../runtime/IOptions';
import { DisplayMode } from '../runtime/IRouteData';
import { IPricingExportOptions } from './IPricingExportOptions';

export class DefaultOptions implements IOptions {
  baseUrl = process.env.VUE_APP_API_PATH;

  application: CatalogAppSettings = {
    appCode: '',
    langCode: 'en',
  };

  export: IPricingExportOptions = {
    pricesEnabled: false,
  };

  styles = [
    {
      url: `${process.env.VUE_APP_STYLE_PATH}/pis-products-theme.css?${process.env.VUE_APP_BUILD}`,
    },
    { url: `${process.env.VUE_APP_STYLE_PATH}/pis-products.css?${process.env.VUE_APP_BUILD}` },
  ];

  components: IComponentOptions = {
    search: {},
    searchForm: {
      visible: true,
      useAutocomplete: true,
    },
    searchToolbar: {
      pageSizes: [10, 20, 50, 100],
      visible: true,
    },
    productsSearchToolbar: {
      visible: true,
      pageSizes: [12, 24, 48, 72],
      displayModes: [DisplayMode.table, DisplayMode.list, DisplayMode.grid],
    },
    searchHeader: {
      visible: true,
    },
    searchProductCategories: {
      visible: true,
      card: true,
      icon: true,
      maxCategoriesVisible: 12,
    },
    searchPartCategories: {
      visible: true,
      card: true,
      icon: true,
      maxCategoriesVisible: 12,
    },
    searchFilters: {
      visible: true,
      card: true,
      icon: true,
      maxFiltersVisible: 10,
      expandedFromNodeLevel: 2,
      visibleFromNodeLevel: 0,
    },
    searchFiltersStatus: {
      visible: true,
    },

    catalogsTable: {
      visible: true,
      columns: [
        {
          headerTemplate: '{{ t("ColumnCode") }}',
          width: '33%',
          dataField: 'code',
        },
        {
          dataField: 'description',
          headerTemplate: '{{ t("ColumnDescription") }}',
          cellTemplate: `
            <span>{{ item.description }}</span>
            <div v-if="item.shared" class="text-muted small">
              <span>{{ t('SharedCatalogEditInSourceSystem') }}</span>
            </div>
          `,
        },
        {
          headerTemplate: '{{ t("ColumnLastModified") }}',
          dataField: 'lastModified',
          width: '140px',
          cellTemplate:
            '{{ new Date(item["lastModified"]).toLocaleString([],{dateStyle:"medium"}) }}',
        },
      ],
    },

    itemsTable: {
      visible: true,
      columns: [
        {
          caption: 'Name',
          dataField: '#DisplayName',
          width: '33%',
          headerTemplate: '{{ t("ProductListProduct",true) }}',
          cellTemplate: `
            <a href class="fw-bold" :class="{'text-muted':item.inactive}" @click.prevent="details(item)">
              {{ attrValue(item, "#DisplayName") }}
            </a>
            <div v-if="item.productType == catalogProductType.Configured" class="text-muted small">
              <em>{{ t('ConfiguredProducts') }}</em>
            </div>
          `,
        },

        {
          caption: 'Description',
          headerTemplate: '{{ t("ProductListInformation",true) }}',
          dataField: 'CatalogDescription',
        },
      ],
    },
    itemsList: {
      imageSize: '6rem',
      visible: true,
      navigateOnContentClick: true,
    },
    itemsGrid: {
      visible: true,
      navigateOnContentClick: true,
    },
    preview: {
      visible: true,
    },

    breadcrumbs: {
      visible: true,
    },
  };
  allowMobileView = true;
  cacheTranslations = false;
}
